module.exports = __webpack_public_path__ + "img/symbol_8.b04f5cd0.png";